import { render, staticRenderFns } from "./Billers.vue?vue&type=template&id=51fabec4"
import script from "./Billers.vue?vue&type=script&lang=js"
export * from "./Billers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports